module.exports = __webpack_public_path__ + "static/media/tesla-clone.74247308.png";